export const Divider = {
  baseStyle: {
    borderColor: 'gray.100',
    borderWidth: '2px'
  }
};
